import type { CartItem } from "../types/cart.types";

export const getCartCount = (items: CartItem[]): number =>
  items.reduce((total, item) => total + item.quantity, 0);

export const getCartTotal = (items: CartItem[]): number =>
  items.reduce((total, item) => total + item.price * item.quantity, 0);
